import { motion } from "framer-motion";
import { Cookie, X } from "lucide-react";
import { Button } from "../ui/button";

export default function CookieBanner({ onAccept }) {
  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      className="fixed bottom-0 left-0 right-0 z-50 p-4"
      data-testid="cookie-banner"
    >
      <div className="container-custom">
        <div className="bg-slate-900 rounded-2xl p-6 shadow-2xl border border-slate-800">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex items-center gap-3 text-white">
              <Cookie className="w-8 h-8 text-amber-400 flex-shrink-0" />
              <div>
                <h4 className="font-semibold mb-1">Cookie Notice</h4>
                <p className="text-slate-400 text-sm">
                  We use cookies to improve your experience on our website. By
                  continuing to browse, you agree to our use of cookies.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <Button
                onClick={onAccept}
                className="bg-teal-500 hover:bg-teal-600 text-white rounded-full px-6"
                data-testid="accept-cookies-btn"
              >
                Accept
              </Button>
              <button
                onClick={onAccept}
                className="text-slate-400 hover:text-white transition-colors"
                data-testid="dismiss-cookies-btn"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
